import TrainersOverview from "./TrainersOverview";

export default TrainersOverview;
